import { jsxs as a, jsx as s } from "react/jsx-runtime";
import { f as n, L as c } from "../../vendor--aJiswR_.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as m } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index27.css';const i = "_lg_iaf9l_1", l = "_md_iaf9l_6", _ = "_sm_iaf9l_11", p = "_progress_iaf9l_15", f = "_bounce-center_iaf9l_1", o = {
  lg: i,
  md: l,
  sm: _,
  progress: p,
  bounceCenter: f
};
function P({ size: e = "md", ...r }) {
  const t = n(o.progress, o[e]);
  return /* @__PURE__ */ a(
    c,
    {
      ...m(r),
      isIndeterminate: !0,
      className: t,
      "aria-label": r["aria-label"],
      "data-component": "DotProgress",
      children: [
        /* @__PURE__ */ s("span", {}),
        /* @__PURE__ */ s("span", {}),
        /* @__PURE__ */ s("span", {})
      ]
    }
  );
}
export {
  P as DotProgress
};
//# sourceMappingURL=index.js.map
